import { giphyBlack, giphyWhite } from '@giphy/js-brand'
import { createContext, useState } from 'react'
import styled from 'styled-components'
import { LoggedInUser } from 'types'
import { margin } from '../constants'
import Giphy from './logo'
import Menu from './menu'
import Nav from './nav'

const containerPadding = `${margin * 2}px 0 1px ${margin}px;`

const Container = styled.div`
    position: relative;
    z-index: 1001;
    padding: ${containerPadding};
    background: ${giphyBlack};
    a {
        color: ${giphyWhite};
        text-decoration: none;
        font-weight: bold;
    }
`

const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
`

type MenuState = undefined | 'user' | 'logged out user' | 'category'

type HeaderContextProps = {
    menu: MenuState
    isSearchVisible: boolean
    setIsSearchVisible: (isVisible: boolean) => void
    setMenuState: (state: MenuState) => void
    user: LoggedInUser | undefined | null
}

export const HeaderContext = createContext({} as HeaderContextProps)

const Header = ({ user, onLogoClick }: { user?: LoggedInUser | null; onLogoClick?: () => void }) => {
    const [menu, setMenuState] = useState<MenuState>(undefined)
    const [isSearchVisible, setIsSearchVisible] = useState(false)
    return (
        <Container>
            <HeaderContext.Provider
                value={{
                    user,
                    menu,
                    setMenuState,
                    isSearchVisible,
                    setIsSearchVisible,
                }}
            >
                <HeaderContainer>
                    <Giphy onClick={onLogoClick} />
                    <Nav />
                </HeaderContainer>
                <Menu
                    onItemClick={(path) => {
                        location.href = path
                    }}
                />
            </HeaderContext.Provider>
        </Container>
    )
}

export default Header
